module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_m_normal.00f3b4b1.png";